import { useState } from "react";
import { NavigationBar } from "./components/atoms/NavBar";
import "./App.css";
import Careers from "./components/pages/careers";
import AboutUs from "./components/pages/aboutUs";
import Details from "./components/pages/details";
import Home from "./components/pages/home";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PrivacyPolicy } from "./pages/privacy-policy/privacy";
import { GoToPortafolioState } from "./types";
import { Success } from "./components/pages/success";

function App() {
  const [goToPortafolio, setGoToPortafolio] = useState<GoToPortafolioState>({
    goToSelectionRef: null,
    scrollTo: null,
  });

  function scrollToPortafolio(goToSelectionRef: any, scrollTo: any): void {
    setGoToPortafolio({
      goToSelectionRef: goToSelectionRef,
      scrollTo: scrollTo,
    });
  }

  return (
    <div className="App">
      <BrowserRouter>
        <NavigationBar
          goToSelectionRef={goToPortafolio.goToSelectionRef}
          scrollTo={goToPortafolio.scrollTo}
        />
        <Routes>
          <Route
            path="/:section"
            element={<Home scrollToPortafolio={scrollToPortafolio} />}
          />
          <Route
            path="/home/:section"
            element={<Home scrollToPortafolio={scrollToPortafolio} />}
          />
          <Route path="/careers" element={<Careers />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/details/:id" element={<Details />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/success/:vacancy" element={<Success />} />
          <Route
            path="*"
            element={<Home scrollToPortafolio={scrollToPortafolio} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
